export default "__VITE_ASSET__71113142__"